import hungaryLang from 'element-ui/lib/locale/lang/hu'
const messages = {
  ...hungaryLang,
  "banner1": "A Solplanet márkát az AISWEI ",
  "banner2": "(korábban SMA China) fejleszti.",
  "banner3": "Napenergia mindenkinek",
  "english": "Angol",
  "polish": "Lengyel",
  "spanish": "Spanyol",
  "turkish": "Török",
  "germany": "Német",
  "french": "Francia",
  "italian": "Olasz",
  "systemData1": "rendszer",
  "installationLocation1": "telepítés",
  "customerData1": "vásárló",
  "claimData": "igény",
  "shippingAddress1": "szállítás",
  "customerData": "Vásárló/ügyfél adatai",
  "customerType": "Kérelmező típusa",
  "selectCustomer": "Kérjük, válassza ki a kérelmező típusát",
  "--None--": "--Nincs--",
  "Installer": "Telepítők",
  "End-customer": "Végfelhasználók",
  "Distributor": "Forgalmazó",
  "EPC": "EPC",
  "Other": "Egyéb",
  "companyName": "Cégnév",
  "typeCompanyName": "Kérjük, adja meg a cég nevét",
  "contacts": "Kapcsolattartási név",
  "typeContacts": "Kérjük, adja meg a kapcsolattartó nevét",
  "contactInformation": "Telefonszám",
  "typeContactInformation": "Kérjük, adja meg a telefonszámot",
  "shippingAddress": "Szállítási cím (Kérjük, vegye figyelembe, hogy csere esetén ez a cím szolgál majd szállítási címként.)",
  "country": "Ország/Terület",
  "typeCountry": "Kérjük,adja meg az ország/terület nevet",
  "province": "Megye",
  "typeProvince": "Kérjük, adja meg a megye nevét",
  "city": "Város",
  "typeCity": "Kérjük, adja meg a városnevet",
  "area": "Utca",
  "typeArea": "Kérjük, adja meg a teljes címet (házszámmal együtt)",
  "contacts01": "Mobiltelefon",
  "typeContacts01": "Kérjük, adja meg a mobiltelefonszámot",
  "postCode": "Irányítószám",
  "typePostCode": "Kérjük, adja meg az irányítószámot",
  "email": "E-mail",
  "typeEmail": "Kérjük, adja meg az e-mail-címet",
  "errorEmail": "Kérjük valós e-mail címet adjon meg!",
  "installationLocation": "Telepítés helye (használja a szállítási címet)",
  "purchaseDate": "A vásárlás dátuma",
  "typePurchaseDate": "Kérjük, adja meg A vásárlás dátuma",
  "installDate": "Telepítés dátuma",
  "typeInstallDate": "Kérjük, adja meg Telepítés dátuma",
  "faultyDeviceType": "A hibás eszköz típusa",
  "selectFaultyDeviceType": "Kérjük, válasszon  A hibás eszköz típusa",
  "faultDate": "A hiba dátuma",
  "typeFaultDate": "Kérjük, adja meg A hiba dátuma",
  "deviceSerialNumber": "Eszköz sorozatszáma",
  "typeDeviceSerialNumber": "Kérjük, adja meg Eszköz sorozatszáma",
  "faultySymptom": "Hibajelenség",
  "selectFaultySymptom": "Kérjük, válasszon   Hibajelenség",
  "errorDescription": "Részletes hibaleírás",
  "typeErrorDescription": "Kérjük, írja be a részletes hibaleírást",
  "purchaseFileId": "Vásárlási bizonylat (melléklet)",
  "purchaseDesc": "(A vásárlást igazoló dokumentumnak tartalmaznia kell az ügyfél nevét, a telepítési címet, az inverter típusát és a fizetés igazolását)",
  "breakFileId": "Kudarcigazolás (melléklet)",
  "breakDesc": "(Kérjük, küldje be fényképen a részletes hibát, a hibaüzenetet és a termék sorozatszám címkéjét)",
  "upload": "Feltöltés",
  "systemData": "Rendszeradatok (opcionális)",
  "systemData01": "Ez a telephely első garanciális igénye",
  "Yes": "Igen",
  "No": "Nem",
  "Unknown": "Nem tudja",
  "systemData02": "Más inverterek működnek ugyanezen a telephelyen",
  "systemData03": "A korábbi garanciális igény oka",
  "enterSystemData03": "Kérjük, adja meg A korábbi garanciális igény oka",
  "systemData04": "Az ugyanazon oldalon található egyéb inverterek meghibásodása",
  "enterSystemData04": "Kérjük, adja meg Az ugyanazon oldalon található egyéb inverterek meghibásodása",
  "systemData05": "Az inverter telepítésének környezeti feltételei",
  "systemData0501": "Beltéri",
  "systemData0502": "Kültéri (az épület egy árnyékos területén vagy napellenző alatt)",
  "systemData0503": "Kültéri (az inverter közvetlen napfénynek van kitéve)",
  "systemData0504": "Víz felett",
  "systemData0505": "Egyéb",
  "systemData06": "A napelem panel telepítésének környezeti feltételei",
  "systemData0601": "Földön",
  "systemData0602": "Tetőn",
  "systemData0603": "Víz felszínén",
  "systemData0604": "Egyéb",
  "systemData07": "A napelempanel márkája és modellje",
  "typeSystemData07": "Kérjük, adja meg A napelempanel márkája és modellje",
  "systemData08": "PV modell",
  "systemData0801": "Független",
  "systemData0802": "Párhuzamos",
  "pleaseSelect": "Kérjük, válasszon",
  "add": "Hozzáadás",
  "delete": "Törlés",
  "pv10": "string napelem panel (db)",
  "pv101": "PV1 string napelem panel (db)",
  "pv102": "PV2 string napelem panel (db)",
  "pv103": "PV3 string napelem panel (db)",
  "pv104": "PV4 string napelem panel (db)",
  "circuit01": "nyitott áramköri feszültség (V)",
  "alternatingVoltage": "Váltakozó feszültség",
  "l1l2": "AC feszültség L1 - L2 (V)",
  "l1n": "AC feszültség L1 - N (V)",
  "l2l3": "AC feszültség L2 - L3 (V)",
  "l2n": "AC feszültség L2 - N (V)",
  "l1l3": "AC feszültség L1 - L3 (V)",
  "l3n": "AC feszültség L3 - N (V)",
  "l1pe": "AC feszültség L1 - PE (V)",
  "l3pe": "AC feszültség L3 - PE (V)",
  "l2pe": "AC feszültség L2 - PE (V)",
  "npe": "AC feszültség N - PE (V)",
  "complaintFileId": "Melléklet",
  "activeTip": "(Megjegyzés: Minél részletesebb információkat tud nyújtani a telepítésről, annál gyorsabban tudjuk azonosítani a problémát.)",
  "submitBtn": "Elküldés",
  "pleaseType": "Kérjük, adja meg",
  "submitSuccess": "Sikeres beküldés",
  "submitDesc": "Néhány kötelező mező nincs kitöltve, kérjük, a megerősítés után küldje el újra. Köszönjük!",
  "typeUpload": "Kérjük, töltse fel",
  "resetUpload": "Újratöltés",
  "selectErrorMessage": "Kérjük, válassza ki a hibaüzenetet",
  "errorMessage": "Egyéb",
  "MPPT": "MPPT",
  "chinese": "Kínai",
  "dutch": "Holland",
  "hungary": "Magyar",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "Elfogadom a Solplanet Általános Szerződési Feltételeit",
  "iagree": "Elfogadom a Solplanet Általános Szerződési Feltételeit",
  "language": "Nyelv",
  "ptbr": "Brazil",
  "zhtw": "Tradícionális Kínai",
  "documentTitle": "Garancia │Solplanet",
  "validateNumber": "Kérjük, adjon meg egy egész számot"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/hungary.js